import { makeAutoObservable } from 'mobx';
import { GroupContextMoreInfoBlobInput } from 'components/common/group/GroupContextMoreInfoBlob';
import { buildGroupContactInfoMap } from 'global/services-helpers/groupService';
import GroupModule from 'store/modules/group/groupModule';

export class EmployeeFlowGroupInfoDelegate {
  private _groupModule: GroupModule;

  public get moreInfoBlobInput(): GroupContextMoreInfoBlobInput | null {
    if (this._groupModule.isLoading) return null;
    const group = this._groupModule.group;

    return {
      blobTitle: group.name,
      generalInfoMap: {
        group: group.name,
      },
      contactInfoMap: buildGroupContactInfoMap(group.contactInfo),
    };
  }

  constructor(groupModule: GroupModule) {
    this._groupModule = groupModule;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
